import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';
import { useUserContext } from '@magento/peregrine/lib/context/user/';
import ResourcesDocumentItem from './resourcesDocumentItem';
import { DownloadResourceIcon } from '/src/components';
import defaultClasses from './resourcesContent.module.css';
import { useMergeCssClasses } from '../../Utils/utils';
import ResourcesVideoItem from './resourcesVideoItem';
import { useResources } from './useResources';

var ResourcesCategory = function ResourcesCategory(_ref) {
  var _resources, _subCategory$items;

  var subCategory = _ref.subCategory,
      _ref$resources = _ref.resources,
      resources = _ref$resources === void 0 ? [] : _ref$resources,
      _ref$categoryId = _ref.categoryId,
      categoryId = _ref$categoryId === void 0 ? null : _ref$categoryId,
      _ref$showDownloadAll = _ref.showDownloadAll,
      showDownloadAll = _ref$showDownloadAll === void 0 ? false : _ref$showDownloadAll,
      propClasses = _ref.classes;

  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var isSmallDevice = innerWidth < 640;

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      customer_flow_map_group = _useUserContext2[0].currentUser.customer_flow_map_group;

  var _useResources = useResources(),
      handleDownload = _useResources.handleDownload;

  var classes = useMergeCssClasses(defaultClasses, propClasses);

  if (subCategory !== null && subCategory !== void 0 && subCategory.items) {
    resources = _toConsumableArray(subCategory.items);
  }

  resources.sort(function (a, b) {
    if (a.sort === null && b.sort === null) {
      var yearA = new Date(a.date).getFullYear();
      var yearB = new Date(b.date).getFullYear();

      if (yearA <= 2023 && yearB <= 2023) {
        return 0;
      }

      return new Date(b.date) - new Date(a.date);
    }

    if (a.sort === null) return 1;
    if (b.sort === null) return -1;
    return +a.sort - +b.sort;
  });
  var resourceItems = (_resources = resources) === null || _resources === void 0 ? void 0 : _resources.map(function (item, index) {
    return categoryId === 9999 ? React.createElement(ResourcesVideoItem, {
      item: item,
      key: index
    }) : React.createElement(ResourcesDocumentItem, {
      item: item,
      key: index
    });
  });
  var areItemsAllowedByCustomerGroup = subCategory.items ? subCategory === null || subCategory === void 0 ? void 0 : (_subCategory$items = subCategory.items) === null || _subCategory$items === void 0 ? void 0 : _subCategory$items.some(function (item) {
    if (item.customer_group) {
      var _item$customer_group;

      return (_item$customer_group = item.customer_group) === null || _item$customer_group === void 0 ? void 0 : _item$customer_group.includes(customer_flow_map_group ? customer_flow_map_group : 'Consumer');
    } else {
      return item;
    }
  }) : true;
  var downloadAddData;

  if (subCategory.name !== 'Search Results') {
    var _subCategory$items2, _subCategory$items2$f, _subCategory$items2$f2;

    downloadAddData = _toConsumableArray(subCategory === null || subCategory === void 0 ? void 0 : (_subCategory$items2 = subCategory.items) === null || _subCategory$items2 === void 0 ? void 0 : (_subCategory$items2$f = _subCategory$items2.filter(function (item) {
      var _item$customer_group2;

      return (_item$customer_group2 = item.customer_group) === null || _item$customer_group2 === void 0 ? void 0 : _item$customer_group2.includes(customer_flow_map_group ? customer_flow_map_group : 'Consumer');
    })) === null || _subCategory$items2$f === void 0 ? void 0 : (_subCategory$items2$f2 = _subCategory$items2$f.filter(function (item) {
      return item === null || item === void 0 ? void 0 : item.url;
    })) === null || _subCategory$items2$f2 === void 0 ? void 0 : _subCategory$items2$f2.reduce(function (acc, curr) {
      return [].concat(_toConsumableArray(acc), [curr === null || curr === void 0 ? void 0 : curr.url]);
    }, []));
  }

  return React.createElement(React.Fragment, null, areItemsAllowedByCustomerGroup && React.createElement("div", {
    className: classes.categoryWrapper
  }, React.createElement("div", {
    className: "flex justify-between border-b border-solid border-bronze pt-0 md_pt-10"
  }, React.createElement("h6", {
    className: "mb-4 text-black font-bold"
  }, subCategory.name), showDownloadAll && React.createElement("button", {
    onClick: function onClick() {
      return handleDownload(downloadAddData);
    },
    className: "invisible sm_visible flex items-center",
    "aria-label": "Download All"
  }, React.createElement("span", {
    className: defaultClasses.hoverIcon
  }, React.createElement(DownloadResourceIcon, null)), React.createElement("span", {
    className: "text-bronze ml-2"
  }, "Download All"))), !isSmallDevice && React.createElement("div", {
    className: "grid grid-cols-10  border-b border-solid border-gray py-3 text-bronze"
  }, React.createElement("div", {
    className: "col-span-4 2xl_col-span-6"
  }, " File name "), React.createElement("div", {
    className: "col-span-1"
  }), React.createElement("div", {
    className: "col-span-2 2xl_col-span-1 text-center"
  }, "Size"), React.createElement("div", {
    className: "col-span-1 text-center"
  }, "Type"), React.createElement("div", {
    className: "col-span-2 2xl_col-span-1 text-center"
  }, " Updated ")), resourceItems));
};

export default ResourcesCategory;